import { render } from "./errorPage3.vue?vue&type=template&id=f5c12c10"
import script from "./errorPage3.vue?vue&type=script&lang=js"
export * from "./errorPage3.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__